<template>
  <v-dialog
    persistent
    v-model="dialog"
    @keydown.esc="dialog = false"
    width="850"
    scrollable
  >
    <v-form ref="form" @submit.prevent lazy-validation v-model="valid">
      <v-card class="elevation-3">
        <v-card-title class="primary text-h5 white--text">
          {{ modalText }}
        </v-card-title>
        <v-card-text class="pa-4">
          <v-row>
            <v-col sm="12">
              <BaseDatePickerWithText
                label="Effective Date mm/dd/yyyy"
                v-model="selectedExciseTaxRateToCity.EffectiveDate"
                :rules="[(v) => !!v || 'required']"
              ></BaseDatePickerWithText>
            </v-col>
          </v-row>
          <v-row>
            <v-col sm="12">
              <LuCity
                label="City"
                v-model="selectedExciseTaxRateToCity.CityID"
              ></LuCity>
            </v-col>
          </v-row>
          <v-row>
            <v-col sm="12">
              <LuExciseTaxRates
                label="Tax Rate"
                v-model="selectedExciseTaxRateToCity.TaxRateID"
              ></LuExciseTaxRates>
            </v-col>
          </v-row>
          <v-row>
            <v-col sm="12">
              <LuExciseTaxTypes
                label="Tax Type"
                v-model="selectedExciseTaxRateToCity.TaxTypeID"
              ></LuExciseTaxTypes>
            </v-col>
          </v-row>
          <v-row>
            <v-col sm="12">
              <v-checkbox
                label="Is Active"
                v-model="selectedExciseTaxRateToCity.IsActive"
                :rules="[(v) => v === true || v === false || 'required']"
              ></v-checkbox>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn
            @click="saveExciseTaxRateToCityDetails"
            :disabled="saving"
            color="primary"
            >Save</v-btn
          >
          <v-btn outlined color="primary" @click="cancelEntry">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>
<script>
import {get, sync, commit, call} from 'vuex-pathify'
import ExciseTaxRateToCity from '@classes/ExciseTaxRateToCity'
//templateTODO: import lookup components you plan to use
import LuCity from '@components/select/single/LuCity'
import LuExciseTaxRates from '@components/select/single/LuExciseTaxRates'
import LuExciseTaxTypes from '@components/select/single/LuExciseTaxTypes'
export default {
  components: {
    //templateTodo: define lookup components you are using
    LuCity,
    LuExciseTaxRates,
    LuExciseTaxTypes,
  },
  data: () => ({
    dialog: false,
    valid: true,
    selectedExciseTaxRateToCity: new ExciseTaxRateToCity(),
    modalText: '',
  }),
  created() {},
  computed: {
    ...get('exciseTaxRateToCity', ['saving']),
  },
  methods: {
    handleError: call('errors/handleError'),
    ...call('exciseTaxRateToCity', ['saveExciseTaxRateToCity']),
    async validate() {
      this.$refs.form.validate()
    },
    editExciseTaxRateToCity(entry) {
      this.selectedExciseTaxRateToCity = new ExciseTaxRateToCity(entry)
      this.modalText = 'Edit Tax Rate To City'
      this.dialog = !this.dialog
    },
    addExciseTaxRateToCity() {
      this.modalText = 'Insert Tax Rate To City'
      this.selectedExciseTaxRateToCity = new ExciseTaxRateToCity()
      this.dialog = !this.dialog
    },
    saveExciseTaxRateToCityDetails() {
      this.validate().then(() => {
        if (this.valid) {
          //templateTODO: if you want to save related item arrays you will need to add a getSaveData() function to the javascript class and call that instead
          this.saveExciseTaxRateToCity(
            this.selectedExciseTaxRateToCity.removeRelated()
          ).then(
            (res) => {
              this.$emit('refresh')
              this.selectedExciseTaxRateToCity = new ExciseTaxRateToCity()
              this.$refs.form.resetValidation()
            },
            (err) => {}
          )
          this.dialog = false
        }
      })
    },
    cancelEntry() {
      this.dialog = false
      this.selectedExciseTaxRateToCity = new ExciseTaxRateToCity()
      this.$refs.form.resetValidation()
    },
  },
}
</script>
<style></style>
